import { useSelector } from "react-redux";

import { availableLanguageCodesSelector } from "@skilitics/nautilus-core-designer-data";

export const useSupportedLanguageCodes = () => useSelector(availableLanguageCodesSelector);
